module.exports = __webpack_public_path__ + "b9f590ee5f4df1e13c12c52489c6839b.svg";